export * from "./KalturaVideoPlayer";
export * from "./CustomPlayer";
export var kalturaSetupHandlerThunk = function kalturaSetupHandlerThunk() {
  var videos = document.querySelectorAll(".tr-kaltura-video-player"); // counts setup total number while internet connection is slow

  var retrySetupCount = 1;
  /**
   * Setup Kaltura Player
   *
   * @param {HTMLElement} video video component which has certain details for Kaltura to setup
   * @param {boolean} initial to track if it is the first setup try for Kaltura Player and reset the counter
   * @returns it either completes setup of the player or throws an error
   */

  var kalturaSetupHandler = function kalturaSetupHandler(video, initial) {
    if (initial) retrySetupCount = 1; // eslint-disable-line curly

    var VIDEO_KS = video.dataset.videoKs;

    try {
      // @ts-ignore
      var kalturaPlayer = window.KalturaPlayer.setup({
        targetId: video.id,
        playback: {
          textLanguage: "auto",
          captionsDisplay: true
        },
        disableUserCache: true,
        provider: {
          partnerId: 2563011,
          uiConfId: 48740763,
          ks: VIDEO_KS
        }
      });
      kalturaPlayer.loadMedia({
        entryId: video.id.replace(/kaltura_video_player__/, "")
      });
    } catch (e) {
      // it gives a try for 2.5 seconds to setup the Kaltura Player
      // otherwise there is a missing part in the script which isn't
      // related to init process
      if (retrySetupCount < 5) {
        retrySetupCount++;
        setTimeout(function () {
          kalturaSetupHandler(video);
        }, 500);
      } else {
        /* eslint-disable no-lonely-if */
        if (e instanceof Error) {
          console.error("Kaltura player setup error:", e.message); // eslint-disable-line no-console
        }
      }
    }
  };

  videos.forEach(function (video) {
    // initial setup, reset the counter for each video
    // doing it here, doesn't as expected due to the V8 engine behavior
    kalturaSetupHandler(video, true);
  });
};